// How a job works, in four steps: one text for the strip on the Jobs page, the first-login tour and the in-app help, so they cannot drift apart.
export const HOW_IT_WORKS = [
  { title: 'Create job', text: 'Press **New job**, or say it in one sentence to the AI.' },
  { title: 'Assign technician + date', text: 'Choose who goes and when. Jobs with both are scheduled; on a draft, press **Schedule**.' },
  { title: 'Technician: Start, Photo, Done', text: 'On the phone, the technician sees only their own jobs: **Start**, **Photo**, **Done**.' },
  { title: 'Done updates maintenance, stock and history', text: 'Tasks are completed, defects closed, parts taken from stock and the log written. Nothing to type twice.' },
]
export const plainText = s => String(s || '').replace(/\*\*/g, '')
